import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import './Settings.css';

// const alert = useAlert();
// var info = `Instructions: \n1. Press the "Toggle Table Menu" button along the settings footer 
//     \n2. Experiment with the settings until you have a view that you're satisfied with
//     \n3. Press the "Toggle Selection Menu" button to view your layout without the menu, if you desire
//     \n4. Once finished adjusting the view, press the "Toggle Scroll Bar" button to remove the scroll from view
//     \n5. Once the view is up to your specifications, press the "Hide Settings" button to remove the settings from view. WARNING: THIS CANNOT BE UNDONE.`

class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tableToggle: false,
            scrollToggle: true,
            hideSettings: false,
            selectionsToggle: true
        }
        this.toggleTableMenu = this.toggleTableMenu.bind(this);
        this.toggleScrollBar = this.toggleScrollBar.bind(this);
        this.removeSettings = this.removeSettings.bind(this);
        this.toggleSelections = this.toggleSelections.bind(this);
    }

    onSettingsChange(e) {
        this.props.onSettingsChange(e);
    }

    toggleTableMenu(e) {
        this.setState(state => ({
            tableToggle: !state.tableToggle
          }));

        var currentSettings = this.props.options;
        currentSettings.tableToggle = !this.state.tableToggle;
        this.onSettingsChange(currentSettings);
    }

    toggleScrollBar(e) {
        this.setState(state => ({
            scrollToggle: !state.scrollToggle
          }));

        var currentSettings = this.props.options;
        currentSettings.scrollToggle = !this.state.scrollToggle;
        this.onSettingsChange(currentSettings);
    }

    removeSettings(e) {
        this.setState(state => ({
            hideSettings: !state.hideSettings
          }));

        var currentSettings = this.props.options;
        currentSettings.hideSettings = !this.state.hideSettings;
        this.onSettingsChange(currentSettings);
    }

    toggleSelections(e) {
        this.setState(state => ({
            selectionsToggle: !state.selectionsToggle
          }));
        
        var currentSettings = this.props.options;
        currentSettings.selectionsToggle = !this.state.selectionsToggle;
        this.onSettingsChange(currentSettings);
    }

    render() {
        return (
            <div className="footer">
                <Button  onClick={this.toggleTableMenu}> Toggle Table Menu </Button>               
                <Button onClick={this.toggleSelections}> Toggle Selection Menu </Button>
                <Button onClick={this.toggleScrollBar}> Toggle Scroll Bar </Button>
                <Button onClick={this.removeSettings}> Hide Settings </Button>
            </div>
        );
    }


}

export default Settings;